import Pusher from 'pusher-js'
import qs from 'qs'
import _ from 'lodash'

import store from 'store'


export const pusher = new Pusher('e1cbb87eeef5a5598aed', {
  cluster: 'eu',
  encrypted: true,
})


let backendHost
let backendAuthHost
let mydFrontEndURL
let googleAnalyticsKey = ''
let environment = process.env.REACT_APP_ENV

const hostname = window && window.location && window.location.hostname

if (
  process.env.REACT_APP_ENV === 'production' ||
  process.env.REACT_APP_ENV === 'production-local'
) {
  backendHost = 'https://api.mydocumenta.com/'
  backendAuthHost = 'https://auth.mydocumenta.com/'
  mydFrontEndURL = 'https://mydocumenta.com/'
  googleAnalyticsKey = 'UA-100583304-3'

} else if (process.env.REACT_APP_ENV === 'dev') {
  backendHost = 'https://api-dev.mydocumenta.com/'
  backendAuthHost = 'https://auth-dev.mydocumenta.com/'
  mydFrontEndURL = 'https://dev.mydocumenta.com/'

} else if (process.env.REACT_APP_ENV === 'test') {
  backendHost = 'https://api.mydocumenta.com/'
  backendAuthHost = 'https://auth.mydocumenta.com/'
  mydFrontEndURL = 'https://test.mydocumenta.com/'

} else if (
  hostname === 'localhost' ||
  process.env.REACT_APP_ENV === 'localhost'
) {
  backendHost = 'http://localhost:5000/'
  backendAuthHost = 'http://localhost:8000/'
  mydFrontEndURL = 'http://localhost:3000/'

}

backendHost = process.env.REACT_APP_BACKEND_HOST || backendHost
backendAuthHost = process.env.REACT_APP_BACKEND_AUTH_HOST || backendAuthHost


export const API_ROOT = backendHost
export const AUTH_ROOT = backendAuthHost
export const mydOauthURL = (redirect=false, params='') => {
  redirect = redirect || window.location.origin
  const state = window.location.pathname

  let sso = window.location.host.split('.')[0]

  return `${AUTH_ROOT}o/authorize?response_type=token&redirect_uri=${encodeURI(redirect)}&state=${encodeURI(state)}&client_id=DSLUA4ZM6sZNKgHBzAW7Ps5fjHcpESjlG17VQgUl${params}&sso=sso-${sso}`
}

export const mydOauthToken = () => {
  const search = qs.parse(window.location.search.replace('?', ''))
  const _hash = qs.parse(window.location.hash.replace('#', ''))
  let token = _.get(search, 'token', false)
  let refreshToken = _.get(search, 'refreshToken', {})
  if ( ! token) {
    token = _.get(_hash, 'access_token', false)
    refreshToken = _.get(_hash, 'refresh_token', {})
  }

  if ( _.isEmpty(token) ) {
    token = localStorage.getItem('mydToken')
    refreshToken = localStorage.getItem('mydRefreshToken')
  }

  if ( token === 'null' ) {
    token = false
  }

  if ( token ) {
    localStorage.setItem('mydToken', token)
    localStorage.setItem('mydRefreshToken', refreshToken)
  }

  if (search?.state) {
    window.redirect(search.state)
  }

  return token
}

export const mydOauthLogoutURL = (redirect=false) => {
  redirect = redirect || window.location.href

  const auth = store.getState().auth
  if (_.get(auth, 'user.actions.redirectOnLogout', false)) {
    redirect = auth.user.actions.redirectOnLogout
  }

  return `http://www.mydocumenta.com/oauth_logout.php?redirect_url=${encodeURI(redirect)}`
}

export const mydWWWOauthUrl = (state, forceRedirect=false) => {
  if (forceRedirect) {
    return state
  }
  return `http://mydocumenta.com/oauth.php?state=${state}&access_token=${mydOauthToken()}`
}

export const MYD_FRONT_END_URL = mydFrontEndURL
export const MYD_ENV = environment
export const bucketBaseUrl = 'http://www.criss.tech/assets/uploads/files/s3-criss'
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV
export const SENTRY_DSN = 'https://58a960161867432b90c6969d9b2df034@sentry.io/1315944'
export const HOTJAR_HJID = 1139419
export const HOTJAR_HJSV = 6
export const HOTJAR_ACTIVE = process.env.REACT_APP_HOTJAR_ACTIVE || true
export const GOOGLE_ANALYTICS_KEY = googleAnalyticsKey
